export const project = [
    {
        title : "Recharge 24",
        description : `Boasting over 100+ events, ranging from music and dance 
        to sports and various other exciting genres, Recharge'24 attracted 
        students from across the nation a platform to showcase their talents.Recharge'24 featured an exciting lineup 
        of celebrities, covering electrifying music performances from musical guests and DJs,
        and also personalities with a sports background.I contributed for it development 
        using the tech stacks such as NextJs,Tailwind.`,
        link : "https://www.rechargefest.in/"
    },
    {
        title : "Student Portal" ,
        description : `Student Portal App is a MERN Stack Web Application developed with technologies such as 
        React,MongoDB,Node,Express,D3.js and Boostrap which have dual login system for admin and students , enables the user to visualize the data as charts and built in Mail system for mark notification.The Admin have rights to edit , delete , and add marks of the student.
        and also create new users`,
        link : "https://github.com/Syed-Javith/mern-student-management.git"
    },
    {
        title : "Hospital Dashboard",
        description : `The Hospital Analytics Dashboard is developed using Power BI to provide comprehensive insights into hospital operations. By analyzing inpatient and outpatient data, the dashboard offers valuable information on patient flow, resource utilization, and top case analysis. Through intuitive graphs and charts, stakeholders can visualize trends and prioritize areas for improvement, enabling informed decision-making and strategic planning for hospital management. With its user-friendly interface and customizable features, the dashboard serves as a vital tool in gaining insights.`,
        link : "https://github.com/Syed-Javith/Hospital-Analytics.git"
    },
    {
        title : "Social Media Bot",
        description : `Social Media Bot is developed using UIPath Studio
        which automates our activity of posting same content across various 
        social media platforms such as instagram , facebook , twitter etc.
        This Automation Bot uses the credentials to login into user account 
        , posts the content and provide a notification upon on completion
        as a Short Message Service(SMS) using Twilio.`,
        link : "https://github.com/Syed-Javith/Social-Media-Bot.git"
    },
    {
        title : "NextJS Blog",
        description : `NextJS Blog is a full stack blog project developed using the NextJS framework with
        prisma ORM to connect to MongoDB and Tailwind to design UI, The Web App has CRUD operations on blogs and also 
        login using both credentials and google with a Profile page for every users.`,
        link : "https://rsj-blogs.vercel.app/"
    },
    {
        title : "Finance Tracker",
        description : `Finance Tracker is a NextJS Application with firebase backend for providing 
        the data and authentication, using this application the users can see their expenses and income 
        and also visualize it using the chartJS for react which make it more inituitive.`,
        link : "https://rsj-finance-tracker.vercel.app/"
    },
    {
        title : "HackOverflowV3" ,
        description : `HackOverflowV3 is a 24 hour hackathon organized by 
        the department of Computer Science and Engineering 
        , where We as team developed a Cool , Interactive and
         Responsive Website using React , Bootstrap and other 
         JavaScript Libraries.`,
         link : "https://hackoverflowv3.netlify.app/"
    },
   
    {
        title : "SIH",
        description : `A basic prototype for Smart India Hackathon.Here the user 
        can share his code , link , tags and experience of the project to enable a 
        peer learning from his/her friends and can collaborate with others.
        In addition to this the admin user can add projects on behalf of the college to showcase talents.`,
        link : "https://github.com/Syed-Javith/sih"
    },
    // {
    //     title : "REC IEEE" ,
    //     description : `REC IEEE is a static webste for the use of IEEE branch
    //     of Rajalakshmi Engineering College.It includes multiple pages for
    //     each society of the REC IEEE association it includes interactive 
    //     animations.`,
    //     link : "https://rajalakshmi.org/ieee/"
    // },
    // {
    //     title : "REC ICCDS",
    //     description : `A Frontend website for the International Conference on Computing and Data Science 
    //     being hosted by Rajalaksmi Engineering College.The Website is built using HTML , CSS , Javascript along 
    //     with Boostrap.`,
    //     link : "https://rajalakshmi.org/iccds24/"
    // },
    
   
]